import { render } from "./proposalListByReserveComponent.vue?vue&type=template&id=ae5684f4"
import script from "./proposalListByReserveComponent.vue?vue&type=script&lang=js"
export * from "./proposalListByReserveComponent.vue?vue&type=script&lang=js"

import "./proposalListByReserveComponent.vue?vue&type=style&index=0&id=ae5684f4&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__